import { forwardRef, ReactNode, useRef } from 'react';
import { BottomSheet, BottomSheetRef } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import * as S from './BottomSheet.styled';

interface BottomSheetProps {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  openHeightRates?: number[] | null;
  /**
   * 블락킹 시 바텀시트 외부 클릭 시 닫히지 않음
   */
  blocking?: boolean;
  footerChildren?: ReactNode;
  hideHandle?: boolean;
  disableContentDrag?: boolean;
  transparentBg?: boolean;
}

const BottomSheetContainer = forwardRef<BottomSheetRef, BottomSheetProps>(
  (
    {
      isOpen,
      onClose,
      children,
      openHeightRates = null,
      footerChildren = null,
      blocking = false,
      hideHandle = false,
      disableContentDrag = false,
      transparentBg = false,
    },
    ref,
  ) => {
    const sheetRef = useRef<BottomSheetRef>(null);

    const bottomSheetRef = ref ?? sheetRef;

    const snapBottomSheetToMax = () => {
      if (!bottomSheetRef || !('current' in bottomSheetRef)) return;

      bottomSheetRef.current?.snapTo(
        ({ maxHeight }: { maxHeight: number }) => maxHeight,
      );
    };

    return (
      <S.Container>
        <BottomSheet
          css={transparentBg ? S.bottomSheetStyle : {}}
          open={isOpen}
          blocking={blocking}
          ref={bottomSheetRef}
          skipInitialTransition
          snapPoints={({ minHeight, maxHeight }) =>
            openHeightRates
              ? openHeightRates.map((rate) => maxHeight * rate)
              : minHeight
          }
          defaultSnap={({ minHeight }) =>
            openHeightRates ? Math.max(...openHeightRates) : minHeight
          }
          expandOnContentDrag={!disableContentDrag}
          footer={footerChildren ?? false}
          header={
            !hideHandle && (
              <S.SnapToMaxHeaderDiv onClick={snapBottomSheetToMax} />
            )
          }
          onDismiss={onClose}
          initialFocusRef={false}
        >
          {/* 미션 바텀시트 컨텐츠 */}
          <S.BottomSheetContent>{children}</S.BottomSheetContent>
        </BottomSheet>
      </S.Container>
    );
  },
);

export default BottomSheetContainer;
